"use client";

import { c as _c } from "react/compiler-runtime";
import { BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";

// DashboardRouterProvider reads useSearchParams, which bails the prerender out
// to the client, so this is the HTML shown until hydration. It mirrors the
// server branch of AuthProvider's initial-load state; the sidebar skeleton
// needs the router and localStorage, so it can only render after hydration.
export function DashboardShellFallback() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-screen items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}